import React from "react";

/* News channel pill-logos with brand colors. Distinctive enough to be recognizable in TIER 2/3 audience */
const Logo = ({ children, bg = "#dc2626", color = "#fff", outline }) => (
  <div
    className="rounded-md py-2 text-center text-[10.5px] font-extrabold tracking-wider"
    style={{ background: bg, color, border: outline ? `1px solid ${outline}` : "none" }}
  >
    {children}
  </div>
);

export default function NewsLogos() {
  return (
    <section className="px-4 mt-4" data-testid="as-seen-on">
      <div className="text-center text-[10px] tracking-[0.2em] font-bold text-slate-500 uppercase mb-2">
        As Featured In
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        <Logo bg="#cc0000" color="#fff">NDTV</Logo>
        <Logo bg="#000000" color="#fff">
          <span style={{ color: "#ffcc00" }}>AAJ</span>{" "}
          <span style={{ color: "#fff" }}>TAK</span>
        </Logo>
        <Logo bg="#d50000" color="#fff">ABP&nbsp;News</Logo>
        <Logo bg="#0a2545" color="#fff">
          NEWS<span style={{ color: "#f59e0b" }}>18</span>
        </Logo>
        <Logo bg="#fff" color="#cc0000" outline="#e2e2e2">India&nbsp;TV</Logo>
        <Logo bg="#0033a0" color="#fff">Times&nbsp;Now</Logo>
        <Logo bg="#fbbf24" color="#000">Republic</Logo>
        <Logo bg="#0b6e4f" color="#fff">Zee&nbsp;News</Logo>
      </div>
    </section>
  );
}
